export function formatWishlistGiftCount(count: number): string {
  const remainder = count % 10;
  const lastTwo = count % 100;
  const noun = count === 1
    ? 'prezent'
    : remainder >= 2 && remainder <= 4 && (lastTwo < 12 || lastTwo > 14)
      ? 'prezenty'
      : 'prezentów';

  return `${count} ${noun}`;
}
